export function EditUndoIcon({ ...props }) {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z"
        fill="inherit"
      />
    </svg>
  );
}
